import React from 'react';

import {DocumentTaskReportPage} from 'app/documents/components/DocumentTaskReportPage';
import {
  useProcedureByHashid,
  useProcedureVersionById,
  useProcedureVersions,
} from 'app/procedures/api';

import {ProcedurePageSidebar} from './ProcedurePageSidebar';

import type {DetailPageBaseProps} from 'app/components/general/DetailPage/types';
import type {ProcedureHashidSerializedType} from 'sweet-types';

export const ProcedureTaskReportPage = ({
  route,
}: DetailPageBaseProps<ProcedureHashidSerializedType>) => (
  <DocumentTaskReportPage
    useData={useProcedureByHashid}
    useDataVersion={useProcedureVersionById}
    useDataVersions={useProcedureVersions}
    SideBarComponent={ProcedurePageSidebar}
    CurrentLeftSidebar={route.props?.CurrentLeftSidebar}
  />
);
